import type { TFunction } from 'i18next';

import { getSignUpAgreementsValidationMessage } from '../../../redux/api/agreements/agreementPolicy';
import { PasswordRegex } from '../../../shared/constants';
import yup from '../../../shared/validation';

export function getSignUpFormValidation(t: TFunction) {
  return yup.object({
    email: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '256'))
      .email(t('formikValidation.emailCorrect'))
      .required(t('formikValidation.emailRequired')),
    password: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '256'))
      .required(t('formikValidation.passwordRequired'))
      .min(8, t('formikValidation.passwordMin'))
      .matches(PasswordRegex, t('formikValidation.passwordPattern')),
    confirmPassword: yup
      .string()
      .required(t('formikValidation.confirmPasswordRequired'))
      .oneOf([yup.ref('password')], t('formikValidation.confirmPasswordMatch')),
    acceptedAgreements: yup
      .boolean()
      .oneOf([true], getSignUpAgreementsValidationMessage(t)),
  });
}
